import apiClient from './apiClient';
import { NurseCertificationCode } from '../types/nurse';

// API応答の型定義
interface CertificationCodesResponse {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: NurseCertificationCode[];
}

// 看護師認証コード一覧を取得
export const fetchNurseCertificationCodes = async (): Promise<NurseCertificationCode[] | CertificationCodesResponse> => {
  const response = await apiClient.get('/external/nurse_certification_codes/');
  
  // APIの応答データを適切な型にキャスト
  if (Array.isArray(response.data)) {
    return response.data as NurseCertificationCode[];
  } else {
    return response.data as CertificationCodesResponse;
  }
};